export enum LANGUAGES {
  en = 'English',
  ja = '日本語',
  // de = 'Deutsch',
 zh = '中文',
}